const normalizeBaseUrl = (url) => (url ? url.replace(/\/+$/, "") : "");

export const API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_API_BASE_URL || "https://nasa-api-app-b9y8.onrender.com"
);

export const NASA_API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_NASA_API_BASE_URL || "https://api.nasa.gov"
);
